import React from 'react'
import { Link } from 'react-router-dom'
import useAsset from '@/hooks/useAsset'

const Footer = () => {
  // Cache-busted asset URL
  const logoWhite = useAsset('/tailtations-white.svg')
  return (
    <footer id="contact" className="bg-black text-white">
      <div className="container mx-auto max-w-7xl px-6 md:px-12">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <div className="mb-6">
              <img src={logoWhite} alt="Tailtations" className="h-16 w-auto" />
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              Revolutionizing street food with gourmet deep-fried lobster tails and cutting-edge technology.
            </p>
            <div className="text-sm text-white/40 space-y-1">
              <p>Los Angeles, CA</p>
              <p>Founded 2025</p>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="md:col-span-2 md:col-start-6">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-5">Quick Links</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/taste" className="text-sm text-white/80 hover:text-white transition-colors">
                Order Online
              </Link>
              <Link to="/catering" className="text-sm text-white/80 hover:text-white transition-colors">
                Event Catering
              </Link>
              <Link to="/wholesale" className="text-sm text-white/80 hover:text-white transition-colors">
                Wholesale
              </Link>
            </nav>
          </div>

          {/* Legal Column */}
          <div className="md:col-span-2">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-5">Legal</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/privacy-policy" className="text-sm text-white/80 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-use" className="text-sm text-white/80 hover:text-white transition-colors">
                Terms of Use
              </Link>
              <Link to="/terms-of-sale" className="text-sm text-white/80 hover:text-white transition-colors">
                Terms of Sale
              </Link>
            </nav>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-2">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-5">Contact</h3>
            <div className="flex flex-col space-y-3">
              <a href="mailto:contact@tailtations.com" className="text-sm text-white/80 hover:text-white transition-colors">
                contact@tailtations.com
              </a>
              <a href="https://www.instagram.com/tailtations/" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                Instagram
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs text-white/40">
              &copy; {new Date().getFullYear()} Tailtations LLC. All rights reserved.
            </p>
            <p className="text-xs text-white/30">
              Los Angeles' Original Fried Lobster Brand
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer